import { Component, OnInit } from '@angular/core';

import { Platform, PopoverController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { AuthState } from './services/auth/auth.model';
import { AuthService } from './services/auth/auth.service';
import { pageView } from './services/menu/menu.pages';
import { MenuService } from './services/menu/menu.service';
import { PlatformService } from './services/platform/platform.service';
import { theme } from './services/theme/theme.model';
import { ThemeService } from './services/theme/theme.service';
import { StateService } from './services/state/state.service';
import { LoadingService } from './services/loading.service';
import { ToastService } from './services/toast.service';
import { Router } from '@angular/router';
import { EventsService } from './services/events.service';
// import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';

@Component({
  standalone: false,
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit {
  isMobileDevice: boolean;
  pages$: Observable<pageView[]>;
  auth$: Observable<AuthState>;
  currentSelected: number = 0;
  selected: number = -1;
  icon;
  hospitals:any[];
  selectedHospital:any = null;
  // show=false;
  public appPages2:any[] ;
  public appPages:any = []
  themes$: Observable<theme[]>;
  currentTheme$: Observable<string>;
  public pages: any;
  whiteListed = ['reset-password', 'register?parent_email', 'forgot-password'];
  whiteListedFlag = this.whiteListed.some((i) =>
    window.location.href.includes(i)
  );
  role: any;
  // role: string;

  constructor(
    private platform: PlatformService,
    private router:Router,
    private menu: MenuService,
    public auth: AuthService,
    private popover: PopoverController,
    private theme: ThemeService,
    public stateService:StateService,
    private loadingService:LoadingService,
    private toastService:ToastService,
    private events:EventsService,
    private plt:Platform
    // private screenOrientation: ScreenOrientation

  ) {
    this.appPages=[];
    this.appPages2=[];
    // set to landscape
// this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);



// detect orientation changes
// this.screenOrientation.onChange().subscribe(
//    () => {
//     this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.PORTRAIT);

//        console.log("Orientation Changed");
//    }
// );


    // this.createStorage();

    // this.isMobileDevice = this.platform.isMobile();
    // this.pages$ = this.menu.pages$;
    // this.auth$ = this.auth.auth$;
    // this.currentTheme$ = this.theme.currentTheme$;
    // this.themes$ = this.theme.themes$;
    // this.checkDevicePlatform();

  }
  async createStorage() {
    // await this.storage.create();
  }

  close(url?) {
    this.menu.collapseMenu();
    let hospital=null;
    hospital=localStorage.getItem('hospital')
    if(url=='home' || url=='users' || url=='hospitals' || url=='hospital/create' || url=='global-settings' || url=='user-setting'){
      this.router.navigate([url]);
    }
    else
    if(hospital){
      this.router.navigate([url]);
    }
    else
    if(url)
    this.toastService.presentSuccessToast('Select a hospital first');

  }

  async checkDevicePlatform() {
    if (!this.whiteListedFlag) {
      if (this.isMobileDevice) {
        await this.router.navigate(['auth/login']);
      } else {
        await this.router.navigate(['auth/login']);
      }
    }
  }

  navigateToPage(url: string) {
    // this.menu.changePage(url);
  }

  async setTheme(color: string) {
    await this.theme.setTheme(color);
  }

   logOut() {
    localStorage.clear();
    this.menu.collapseMenu();
     this.auth.logout();

     this.router.navigate(['auth/login'], { replaceUrl: true });
  }
  openPage(p: any) {}

  setId(i: number) {
    this.currentSelected = i;
    this.selected = -1;
  }
  setCurrent(i: number) {
    this.selected = i;
    this.currentSelected = -1;
  }
  async logout(){
    await this.auth.logout().then(()=>{
      this.menu.collapseMenu;
      this.router.navigate(['login'])
    })
  }
   initializeState(){

    // setTimeout(async () => {
      // await this.loadingService.presentLoading('')
      const storedHospital = localStorage.getItem('hospital');
      // Clean up invalid hospital values stored by legacy code (e.g. "[object Object]")
      if (storedHospital && (storedHospital === '[object Object]' || storedHospital === 'null' || storedHospital === 'undefined')) {
        localStorage.removeItem('hospital');
        this.selectedHospital = null;
      } else {
        // Parse to number so ng-select bindValue="id" (number) matches correctly
        const num = storedHospital ? Number(storedHospital) : null;
        this.selectedHospital = (num && !isNaN(num)) ? num : null;
      }
      this.role=localStorage.getItem('role')
     
  
    if(!this.role  )
    {
      this.stateService.getRole().subscribe(res=>{
        this.role=res.data.role_id
        localStorage.setItem('role',res.data.role_id)
        this.setAppPages(res.data.role_id)
      })
    }
    else
    this.setAppPages(this.role);
  

  }
  setAppPages(role){
    // debugger
    this.appPages=[]
    this.appPages=[


      // {
      //   name: 'Dashboard',

      //   sort: 'assets/hospital/side menu/Dashboard.svg',
      //   sub: [{ title: 'Home', url: 'home' }],
      // },

      {
        name: 'Product Categories',

        sort: 'assets/hospital/side menu/Products.svg',
        sub: [
          // { title: 'Dashboard', url: 'product-dashboard' },
          { title: 'Arterials', url: 'arterial' },
          { title: 'Endurance', url: 'endurance' },
          { title: 'CVC', url: 'cvc' },
          { title: 'Midlines', url: 'midlines' },
          { title: 'VPS Rhythm DLX PICC and JACC', url: 'dlx-rhythm' },
          { title: 'VPS G4 PICC and JACC', url: 'g4-picc' },
        ],
      },
      {
        name: 'Resource Library',

        sort: 'assets/hospital/side menu/Resource.svg',
        sub: [
          { title: 'Files', url: 'files' },
          { title: 'Category', url: 'category' },
        ],
      },


    ];
    this.appPages2= [

      {
        name: 'Calendar',

        sort: 'assets/hospital/side menu/Calendar.svg',
        url: 'events',
      },
      {
        name: 'Timeline',

        sort: 'assets/hospital/side menu/Timeline.svg',
        url: 'timeline',
      },

    ];
    // console.log('role is',this.role)
    if(role=='1' || role=='2'){
      // console.log('yeeeessss')
      this.appPages.push({
        name: 'User Management',

        sort: 'assets/hospital/side menu/Calendar.svg',
        sub: [{ title: 'View Users', url: 'users' }],
      },
      {
        name: 'Hospitals',

        sort: 'assets/hospital/side menu/Interview.svg',
        sub: [
          { title: 'Create Hospital', url: 'hospital/create' },
          { title: 'View Hospitals', url: 'hospitals' },
        ],
      },)
      this.appPages2.push(  {
        name: 'Global Settings',

        sort: 'assets/hospital/side menu/FAQ.svg',
        url: 'global-settings',
      },)
    }
  
   this.getHospitals();
  //  this.getHospitals();
  // },3000);

  }
  async getHospitals(){
    await this.loadingService.presentLoading('')
    this.stateService.getHospitals().subscribe(async res=>{
      this.hospitals=res.data;

      this.hospitals.forEach((hospital) => {
        // console.log(hospital);
        if (hospital.id == this.selectedHospital) {
          this.selectedHospital = hospital.id;
          this.stateService.hospitalId=hospital.id;
          // console.log(this.selectedHospital);
          // this.show=true;
        }

      });
     
      await this.loadingService.dismissLoader();
      // localStorage.getItem('hospital').then(async res=>{
      //   this.selectedHospital=res;
      //   this.stateService.hospitalId=res;
      //    
      //   // await this.loadingService.dismissLoader();
      // },error=>{
      //   // this.loadingService.dismissLoader();
      //   this.toastService.presentErrorToast(error.error.message)
      // });
    },async error=>{
      console.error('Error fetching hospitals:', error);
      await this.loadingService.dismissLoader();
      // Don't show error toast if user is not logged in
      if (localStorage.getItem('token')) {
        this.toastService.presentErrorToast('Failed to fetch hospitals');
      }
    });
  }

  ngOnInit(){
    // alert(1)
    // this.plt.ready().then(()=>{
      // Only initialize state if user is already logged in (has token)
      const token = localStorage.getItem('token');
      const user = localStorage.getItem('user');
      if (token && user) {
        this.initializeState();
      }
    // })

    this.events.subscribe('user:login', (user) => {
      // alert(1)
      this.stateService.getHospitals().subscribe(res=>{
        this.hospitals=res.data;
        this.initializeState();
      })
      // No need to call updateState again as it's already monitoring auth changes
    });
    this.events.subscribe('hopsital:change', (state) =>{
      const h = localStorage.getItem('hospital');
      const num = h ? Number(h) : null;
      this.selectedHospital = (num && !isNaN(num)) ? num : null;
    })
    this.events.subscribe('hospital_change',(state)=>{
      const h = localStorage.getItem('hospital');
      const num = h ? Number(h) : null;
      this.selectedHospital = (num && !isNaN(num)) ? num : null;
    })
  }
  async setHospital(event){
    // ng-select with bindValue="id" passes the id directly; guard against object being passed
    const hospitalId = (event !== null && typeof event === 'object') ? event.id : event;
    this.stateService.hospitalId=hospitalId;
    localStorage.setItem('hospital', hospitalId != null ? String(hospitalId) : '');
    this.events.publish('hospital_update',true);


  }
  checkhospital(){
    // console.log('side menu open')
    if(!this.hospitals){
      this.getHospitals();
    }
  }
}
